<template>
  <div class="contact">
    <div class="d-flex flex-column align-items-center justify-content-around">
      <h3><strong>Address</strong></h3>
      <p>Next to the Inn of the Prancing Pony</p>
      <p>Bree, Shire</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactView',
}
</script>
